import { render } from "./form-message.vue?vue&type=template&id=77598f16"
import script from "./form-message.vue?vue&type=script&lang=js"
export * from "./form-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__